import { render, staticRenderFns } from "./allinpay_set_paypwd.vue?vue&type=template&id=75563cd3&scoped=true"
import script from "./allinpay_set_paypwd.vue?vue&type=script&lang=js"
export * from "./allinpay_set_paypwd.vue?vue&type=script&lang=js"
import style0 from "./allinpay_set_paypwd.vue?vue&type=style&index=0&id=75563cd3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75563cd3",
  null
  
)

export default component.exports